import { useApiQuery } from '@/api/main/query'
import { useToast } from '@/shared/hooks'
import { useEffect, useState } from 'react'
import { deviceAPI } from '../api/endpoints'
import { defaultDeviceData, DeviceModel } from '../types/types'

export const useGetDeviceData = ({ deviceId }: { deviceId: string }) => {
  const { addToast } = useToast()
  const [deviceData, setdeviceData] = useState<DeviceModel>(defaultDeviceData)

  const shouldFetch = !!deviceId && deviceId !== 'Нет данных'

  const query = useApiQuery<DeviceModel>(
    ['device', deviceId],
    deviceAPI.getDevice(deviceId),
    undefined,
    {
      enabled: shouldFetch,
    }
  )

  useEffect(() => {
    if (query.data) {
      setdeviceData({ ...defaultDeviceData, ...query.data })
    }
  }, [query.data])

  useEffect(() => {
    if (query.error) {
      addToast('Ошибка!', query.error.message, 'error')
    }
  }, [query.error])

  return { deviceData, isLoading: query.isLoading, isPending: query.isPending }
}
